module.exports = __webpack_public_path__ + "img/Vermutete_Gefahr_durch_Explosion.6f8701f3.svg";